import React from 'react'
import { Link } from 'gatsby'
import LinkIcon from '~/components/core/linkIcon'
import { useSelector, useDispatch } from 'react-redux'

import trads from '~/intl/trads.json'

import HitOther from '~/components/features/search/hitOther'

import { setHasLaboOpen } from '~/store/actions'
import scrollManager from '~/utils/scrollManager'

const HitsSection = ({ contentType, hits, emptyResults = false }) => {
  const dispatch = useDispatch()

  const lang = useSelector((state) => state.lang)
  const query = useSelector((state) => state.currentSearchQuery)

  return (
    <div className="labo__section">
      <div className="flex justify-between mb-6">
        <p className="title-block title-block--no-margin pr-4 pb-2 sm:pb-0">
          {trads[lang].lab.titleContentTypes[contentType]}
        </p>

        {hits.length > 3 && (
          <Link
            onClick={() => {
              dispatch(setHasLaboOpen(false))
              scrollManager.restart()
            }}
            to={
              lang === 'fr'
                ? `/recherche?q=${encodeURI(query)}`
                : `/en/search?q=${encodeURI(query)}`
            }
            state={{ filters: [contentType], searchQuery: query }}
          >
            <LinkIcon
              text={`<span class="hidden md:block">${trads[lang].lab.linkContentTypes[contentType]}</span>
              <span class="md:hidden" aria-hidden="true">${trads[lang].lab.seeAllMobile}</span> <sup class='labo__results-number'>(${hits.length})</sup>`}
            />
          </Link>
        )}
      </div>

      <ul>
        {hits.slice(0, 3).map((hit, i) => {
          hit.contentType = contentType

          return (
            <li key={i} className="mb-4">
              <HitOther hit={hit} emptyResults={emptyResults} />
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default HitsSection
